export default __webpack_public_path__ + "static/left-phone-b5e1f410b7a6591086d06c27518804ba.webp";